import React from 'react';
import { Box } from '@mui/material';
import { ProgressIndicatorProps } from '../types';

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentIndex,
  totalQuestions,
  completedQuestions,
}) => {
  if (totalQuestions <= 1) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 1,
      }}
    >
      {Array.from({ length: totalQuestions }, (_, index) => {
        const isCompleted = completedQuestions.includes(index);
        const isCurrent = index === currentIndex;

        return (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: isCompleted || isCurrent ? 'primary.main' : 'action.disabled',
              transition: 'all 200ms ease-in-out',
              transform: isCurrent ? 'scale(1.2)' : 'scale(1)',
              opacity: isCompleted || isCurrent ? 1 : 0.6,
            }}
            data-testid={`progress-dot-${index}`}
          />
        );
      })}
    </Box>
  );
};
